import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone',
    standalone: false
})
export class PhonePipe implements PipeTransform {

  transform(value: string | number): unknown {
    const digits = String(value).replace(/\D/g, '');
    if (digits.length !== 10) value;
    return `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6)}`;
  }

}
